import React from 'react';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

type EditRubricEditButtonProps = Pick<TouchTargetProps, 'behavior'>;

const EditRubricEditButtonIcon: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g>
        <path
          d="M7.52957 1.99983C7.5063 1.97567 7.47832 1.95655 7.44736 1.94365C7.4164 1.93075 7.38311 1.92434 7.34957 1.92483C7.28434 1.92444 7.22154 1.94956 7.17457 1.99483L1.71457 7.45483C1.69114 7.47807 1.67254 7.50572 1.65985 7.53619C1.64716 7.56665 1.64062 7.59933 1.64062 7.63233C1.64062 7.66533 1.64716 7.69801 1.65985 7.72848C1.67254 7.75894 1.69114 7.78659 1.71457 7.80983L4.18457 10.2798C4.23227 10.3277 4.29701 10.3547 4.36457 10.3548C4.39727 10.3546 4.4296 10.3479 4.45966 10.335C4.48971 10.3221 4.51689 10.3034 4.53957 10.2798L9.99457 4.82483C10.0407 4.77726 10.0665 4.71359 10.0665 4.64733C10.0665 4.58107 10.0407 4.51741 9.99457 4.46983L7.52957 1.99983Z"
          fill={fillColor}
        />
        <path
          d="M1.21296 8.40047C1.18081 8.37051 1.14145 8.34937 1.09872 8.33909C1.05599 8.32882 1.01133 8.32977 0.969066 8.34184C0.926807 8.35392 0.888386 8.37671 0.85753 8.40801C0.826674 8.4393 0.804432 8.47805 0.79296 8.52047L0.0379598 11.6555C0.0279545 11.6973 0.0291568 11.7411 0.0414455 11.7824C0.0537343 11.8236 0.0766757 11.8609 0.10796 11.8905C0.138092 11.9209 0.17542 11.9433 0.216494 11.9556C0.257568 11.9678 0.301063 11.9695 0.34296 11.9605L3.49796 11.2055C3.54096 11.1952 3.58039 11.1736 3.61208 11.1428C3.64377 11.112 3.66653 11.0732 3.67796 11.0305C3.68957 10.9879 3.69016 10.9431 3.67966 10.9002C3.66916 10.8573 3.64793 10.8179 3.61796 10.7855L1.21296 8.40047Z"
          fill={fillColor}
        />
        <path
          d="M11.5951 1.46024L10.5351 0.40024C10.2993 0.167565 9.9814 0.0371094 9.65013 0.0371094C9.31887 0.0371094 9.00093 0.167565 8.76513 0.40024L8.06013 1.11024C8.03622 1.13268 8.01716 1.15979 8.00413 1.18989C7.9911 1.21999 7.98437 1.25244 7.98438 1.28524C7.98437 1.31804 7.9911 1.35049 8.00413 1.38059C8.01716 1.41069 8.03622 1.43779 8.06013 1.46024L10.5351 3.96024C10.5576 3.98416 10.5847 4.00322 10.6148 4.01625C10.6449 4.02928 10.6773 4.036 10.7101 4.036C10.7429 4.036 10.7754 4.02928 10.8055 4.01625C10.8356 4.00322 10.8627 3.98416 10.8851 3.96024L11.5951 3.22524C11.8287 2.99093 11.9599 2.67358 11.9599 2.34274C11.9599 2.0119 11.8287 1.69455 11.5951 1.46024Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export const EditRubricEditButton: React.FC<EditRubricEditButtonProps> = ({
  behavior,
}) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.editRubricEditButtonLabel()}
      icon={<EditRubricEditButtonIcon />}
      behavior={behavior}
      typographyClassName="text-xs"
    />
  );
};
